import React, { createContext, useContext, useEffect, useState } from 'react';

import { useBackendRoute } from './BackendRoute';
import { getTokenFromCookie } from './utils/cookieUtils';

const GuestContext = createContext(null);

export function GuestProvider({ children }) {
  const [guestDetails, setGuestDetails] = useState(null);

  return (
    <GuestContext.Provider value={{ guestDetails, setGuestDetails }}>
      {children}
    </GuestContext.Provider>
  );
}

export function useGuest() {
  const ctx = useContext(GuestContext);
  if (!ctx) throw new Error('useGuest must be used within a GuestProvider');
  return ctx;
}
